import { useQuery } from "react-query";
import { getRequest } from "../../apiRequest";
import { queryKeys } from "./queryKeys";

function fetchKnowledgebase(product) {
  const pathParams = { ...(product && { product }) };
  return getRequest("knowledgebase", null, pathParams).then(
    (res) => res?.data?.data?.knowledgeBaseInfo
  );
}

export function useKnowledgebase(product) {
  return useQuery(
    queryKeys.knowledgebase(product),
    () => fetchKnowledgebase(product),
    {
      staleTime: 5 * 60 * 1000,
      refetchInterval: 60 * 60 * 1000,
    }
  );
}
